import { useLanguage } from "@/context/LanguageContext";
import { ASSETS, SOURCES } from "@/data/content";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-white/5 bg-[#05070B]" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-4 py-12 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <div className="flex items-center gap-4">
          <span className="flex items-center rounded-md bg-white px-2 py-1">
            <img src={ASSETS.logoIkons} alt="IKONS by Solocracks" className="h-5 w-auto" />
          </span>
          <div>
            <p className="font-display text-sm font-bold uppercase tracking-[0.18em] text-slate-200">
              Adrián Cuadra
            </p>
            <p className="text-xs text-slate-500">{t.footer.tag}</p>
          </div>
        </div>

        <div>
          <p className="mb-2 font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-500">
            {t.footer.sources}
          </p>
          <div className="flex gap-5">
            <a
              href={SOURCES.sofascore}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-sofascore-link"
              className="text-xs font-semibold uppercase tracking-wider text-slate-400 transition-colors hover:text-sky-300"
            >
              SofaScore
            </a>
            <a
              href={SOURCES.transfermarkt}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-transfermarkt-link"
              className="text-xs font-semibold uppercase tracking-wider text-slate-400 transition-colors hover:text-sky-300"
            >
              Transfermarkt
            </a>
          </div>
        </div>

        <p className="text-xs text-slate-600">{t.footer.rights}</p>
      </div>
    </footer>
  );
}
